import React from 'react'
import * as v from 'variables/styles'
import { purchaseOrderDetailPath, contractDetailPath } from 'routes'

const linkStyle = {
  color: v.ezMainColor,
  fontWeight: 'bold',
  textDecoration: 'underline',
  cursor: 'pointer',
}

const headerStyle = {
  color: v.ezMainColor,
  fontWeight: 'bold',
}

export const blItemColumns = [
  {
    Header: 'PO No.',
    accessor: 'sapPoNumber',
    className: 'center',
    Cell: row => <div style={linkStyle} onClick={() => window.open(purchaseOrderDetailPath(row.original.poId), '_blank')} >{row.value}</div>
  }, {
    Header: 'Contract No.',
    accessor: 'contractItems',
    className: 'center',
    Cell: row => <React.Fragment>
      <div>
        {
          row.value ? row.value.map((x, i) => {
            return <div style={linkStyle} onClick={() => window.open(contractDetailPath(x.contractId), '_blank')} >{x.contractNo}</div>
          }) : <div>-</div>
        }
      </div>
    </React.Fragment>
  }, {
    Header: 'Contract Status',
    accessor: 'contractItems',
    className: 'center',
    resizable: false,
    Cell: row => <React.Fragment>
      <div>
        {
          row.value ? row.value.map((x, i) => {
            return <div style={headerStyle}>{x.contractStatus}</div>
          }) : <div>-</div>
        }
      </div>
    </React.Fragment>
  }
]